var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#78a3cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8.75h30v12.5H0v-12.5Z",
    style: {
      fill: "#f5e03d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10h30v10H0v-10Z",
    style: {
      fill: "#c20002"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.142,13.6h17.856v.286H6.142v-.286Z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.024,13.911H6.117v-.336h17.906v.336h0ZM6.167,13.861h17.806v-.236H6.167v.236Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.773,13.74h.006v.133h-.006v-.133ZM23.173,13.74h.006v.133h-.006v-.133ZM23.073,13.74h.006v.133h-.006v-.133ZM22.973,13.74h.006v.133h-.006v-.133ZM22.873,13.74h.006v.133h-.006v-.133Z",
    style: {
      fill: "#d8d8d8"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.204,13.898h-.056v-.183h.056v.183ZM23.104,13.898h-.056v-.183h.056v.183ZM23.004,13.898h-.056v-.183h.056v.183ZM22.904,13.898h-.056v-.183h.056v.183ZM22.804,13.898h-.056v-.183h.056v.183Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.079,14.491h17.857v.286H5.079v-.286Z",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.961,14.802H5.054v-.336h17.907s0,.336,0,.336ZM5.104,14.752h17.807v-.236H5.104v.236Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.7,14.205v.857l1.667-.429-1.667-.428ZM23.767,13.297v.857l1.667-.429-1.667-.428Z",
    style: {
      fill: "#999"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.675,15.095v-.922l1.698.437v.048l-1.698.437ZM22.725,14.237v.793l1.541-.396-1.541-.397ZM23.742,14.187v-.922l1.698.437v.048l-1.698.437ZM23.792,13.33v.793l1.541-.396-1.541-.397Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.04,13.089l.314-1.211.224,1.457-.045-1.727.561,1.794-.404-1.704.695,1.637-.336-1.727",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.991,15.333h24.285v.429H2.991v-.429Z",
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.303,15.789H2.964v-.483h24.339s0,.483,0,.483ZM3.018,15.735h24.231v-.375H3.018v.375Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.474,15.028c-1.003,2.258-3.665,4.258-7.474,4.258-3.333,0-5.714-2.857-7.143-4.286,1.429-1.429,3.809-4.286,7.143-4.286,3.809,0,6.269,1.893,7.47,4.309h.01-.003l-.003.005h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999,19.311c-2.997,0-5.216-2.29-6.684-3.805-.169-.174-.328-.339-.477-.488l-.017-.018.018-.018c.148-.148.307-.312.476-.486,1.468-1.516,3.687-3.807,6.685-3.807,1.806,0,3.396.421,4.727,1.252,1.176.735,2.133,1.797,2.766,3.071l-.013.006v.006l.017-.005.003.009-.004.01c-.522,1.176-1.479,2.237-2.694,2.987-1.362.841-3.023,1.286-4.803,1.286ZM7.892,15c.144.144.298.303.46.47,1.462,1.509,3.672,3.79,6.648,3.79,4.1,0,6.572-2.276,7.446-4.23-.799-1.605-2.828-4.29-7.446-4.29-2.977,0-5.187,2.282-6.649,3.792-.162.166-.315.324-.459.468Z",
    style: {
      fill: "#000000"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.501,12.205c.38.427.063.6.465.628.424.031-.153.541.204.556.249.011.087.895.327,1.224.245.343.248.123.252.371.004.256-.374.23-.386,1.02-.02.455-.431.484-.457.777-.032.275.38.452.365.699-.015.246-.165.185-.216.465-.026.252.793.525.925,1.253-.246.08-.453.089-.982.089-3.333.002-5.714-1.198-7.476-4.286,1.83-3.223,4.143-4.286,7.477-4.286,0,0-.988.903-.498,1.49h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.692,15.239c.039-.14,1.26-.216,1.413-.045.106.118.109.625-.034.751-.205.181-1.35.134-1.379.011-.036-.158-.033-.598,0-.717Z",
    style: {
      fill: "#6b3f2a"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.37,16.089c-.249,0-.492-.024-.609-.061-.057-.018-.086-.039-.092-.066-.039-.168-.033-.61,0-.73h0c.007-.025.034-.062.188-.098.335-.078,1.133-.107,1.267.043.068.077.09.277.081.431-.005.08-.025.274-.116.355-.102.091-.415.126-.719.126ZM23.717,15.951s.01.021.11.043c.321.073,1.077.066,1.228-.068.053-.047.091-.167.1-.321.01-.173-.018-.339-.068-.395-.108-.121-.875-.108-1.219-.028-.141.033-.151.062-.151.063-.032.113-.037.547,0,.706h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.763,14.619v-1.143M10.722,13.476v1.143M11.682,13.476v1.143M9.763,16.524v-1.143M10.722,15.381v1.143M11.682,15.381v1.143M12.641,14.619v-1.143M13.6,13.476v1.143M14.56,13.476v1.143M12.641,16.524v-1.143M13.6,15.381v1.143M14.56,15.381v1.143"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.733,16.524h-.346v-1.143h.346v1.143ZM13.773,16.524h-.346v-1.143h.346v1.143ZM12.814,16.524h-.346v-1.143h.346v1.143ZM11.855,16.524h-.346v-1.143h.346v1.143ZM10.896,16.524h-.346v-1.143h.346v1.143ZM9.937,16.524h-.347v-1.143h.346v1.143h.001ZM14.733,14.619h-.346v-1.143h.346v1.143ZM13.773,14.619h-.346v-1.143h.346v1.143ZM12.814,14.619h-.346v-1.143h.346v1.143ZM11.855,14.619h-.346v-1.143h.346v1.143ZM10.896,14.619h-.346v-1.143h.346v1.143ZM9.937,14.619h-.347v-1.143h.346v1.143h.001Z",
    style: {
      fill: "#fff"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.533,14.619v-1.143M16.492,13.476v1.143M17.452,13.476v1.143M15.533,16.524v-1.143M16.492,15.381v1.143M17.452,15.381v1.143M18.411,14.619v-1.143M19.37,13.476v1.143M20.33,13.476v1.143M18.411,16.524v-1.143M19.37,15.381v1.143M20.33,15.381v1.143"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.503,16.524h-.346v-1.143h.346v1.143ZM19.543,16.524h-.346v-1.143h.346v1.143ZM18.584,16.524h-.346v-1.143h.346v1.143ZM17.625,16.524h-.346v-1.143h.346v1.143ZM16.666,16.524h-.346v-1.143h.346v1.143ZM15.707,16.524h-.347v-1.143h.346v1.143h.001ZM20.503,14.619h-.346v-1.143h.346v1.143ZM19.543,14.619h-.346v-1.143h.346v1.143ZM18.584,14.619h-.346v-1.143h.346v1.143ZM17.625,14.619h-.346v-1.143h.346v1.143ZM16.666,14.619h-.346v-1.143h.346v1.143ZM15.707,14.619h-.347v-1.143h.346v1.143h.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.568,15.377c-.216.375.166-.125,1.099.503.173.117.324.424.324.638-.044-.029-.076-.095-.125-.137-.068.068.065.379.084.526-.146-.082-.132-.12-.18-.221.01.121-.07.343-.012.472-.115-.033-.085-.193-.145-.211.041.146-.013.349.007.513-.067-.066-.206-.231-.237-.258-.005.078-.084.35-.087.424-.057-.034-.14-.178-.149-.214-.071.089-.368.261-.384.361-.194-.171-.557-.163-.621-.384-.057.126-.14.168-.304.26-.065-.351-.306-.746-.177-1.047-.092.054-.167.109-.259.176.087-.509.529-1.106,1.166-1.401h0Z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.777,17.814l-.029-.026c-.078-.069-.185-.108-.289-.146-.135-.049-.264-.096-.32-.203-.057.097-.138.142-.271.217l-.045.026-.005-.029c-.021-.112-.061-.232-.099-.347-.075-.224-.152-.455-.097-.654-.068.043-.13.088-.206.143l-.043.031.009-.052c.095-.554.576-1.134,1.172-1.413l.003-.005h.013l.005.025.013.007c-.017.029-.061.106-.056.121.007.006.049.005.086.004.17-.004.525-.013,1.063.349.175.118.333.43.333.656v.04l-.033-.022c-.027-.018-.048-.045-.07-.074-.012-.016-.024-.031-.037-.046-.014.057.024.194.053.297.021.072.04.141.047.192l.006.042-.037-.021c-.102-.057-.131-.096-.153-.145-.003.025-.007.051-.011.078-.015.102-.032.217,0,.291l.019.042-.044-.013c-.06-.017-.086-.064-.102-.109,0,.052-.003.107-.006.16-.005.077-.011.157-.002.227l.008.061-.044-.043c-.035-.034-.088-.095-.136-.148-.026-.03-.052-.058-.071-.079-.008.044-.022.104-.037.166-.021.087-.042.177-.044.213v.036s-.032-.019-.032-.019c-.052-.032-.117-.134-.145-.193-.033.032-.082.07-.134.109-.095.073-.213.163-.222.216l-.011.038ZM25.146,17.327l.016.055c.035.119.169.168.312.22.098.036.199.073.279.134.034-.064.131-.139.226-.211.064-.049.124-.095.15-.128l.027-.033.011.041c.008.029.065.128.112.178.008-.046.024-.112.04-.18.02-.082.04-.167.042-.203l.003-.043.032.028c.016.014.057.06.104.113.031.035.064.072.093.103-.002-.057.002-.117.006-.175.007-.101.014-.196-.008-.274l-.011-.038.038.012c.036.011.047.051.06.092.01.034.02.07.043.094-.015-.079,0-.174.012-.261.009-.062.018-.121.015-.164l.041-.011c.01.021.018.04.025.057.021.052.034.084.107.131-.009-.041-.023-.09-.037-.14-.044-.157-.086-.304-.033-.358l.014-.014.015.013c.024.021.043.046.062.07.008.011.016.021.024.03-.022-.205-.163-.468-.312-.568-.526-.354-.871-.345-1.038-.341-.069.002-.107.003-.124-.025-.013-.022-.006-.05.023-.105-.54.273-.974.794-1.083,1.302.075-.055.14-.099.217-.145l.056-.033-.026.06c-.084.196-.002.443.078.682.036.107.073.217.095.324.144-.081.218-.123.269-.236l.025-.053Z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.039,15.738c-.012-.109.011-.122-.056-.205.098.041.101.15.22.073.044-.023.063-.023.01-.145.124.006.53.145.595.148.171.008.482-.179.698.051.208.21.138.428.138.718-.083-.04-.043-.06-.132-.164.066.254-.004.712-.004.981-.034-.065-.029-.037-.062-.104-.089.246-.105.005-.105.296-.032-.114-.113-.157-.149-.217-.086.187-.461.212-.239.4-.201-.118-.401-.15-.492-.256-.039.025-.227.14-.264.206-.353-.162-.137-.042-.413-.276-.048.098-.026.084-.078.243-.056-.222-.071-.363-.134-.526-.054.09-.049.056-.148.192-.041-.27-.107-.334-.081-.513-.105.074-.036.044-.141.135.101-.689.53-1.201.837-1.037h0Z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.941,17.593c-.082-.048-.166-.083-.24-.113-.098-.04-.185-.076-.242-.132-.137.087-.217.149-.236.185l-.012.022-.022-.01c-.064-.029-.11-.05-.142-.064-.088-.039-.092-.041-.127-.077-.02-.02-.051-.053-.124-.115-.013.031-.017.048-.024.075-.006.027-.015.065-.038.134l-.029.088-.023-.09c-.02-.078-.035-.148-.048-.209-.02-.094-.038-.178-.067-.263-.012.016-.021.026-.032.038-.017.019-.04.044-.088.11l-.038.053-.01-.065c-.016-.106-.036-.181-.053-.241-.021-.077-.037-.138-.034-.217-.01.009-.014.014-.018.02-.01.014-.022.032-.073.077l-.054.047.01-.071c.069-.482.306-.914.576-1.051.089-.045.177-.054.256-.027,0-.01,0-.019,0-.027,0-.049-.002-.065-.045-.118l.031-.042c.039.016.065.042.085.063.036.036.051.051.11.012l.01-.005c.025-.013.03-.015-.01-.106l-.017-.039.043.002c.075.003.24.051.386.093.091.026.185.054.209.055.046.002.107-.012.172-.027.17-.039.381-.088.545.086.172.174.162.355.151.564-.003.055-.006.112-.006.172v.042l-.038-.018c-.043-.021-.059-.038-.072-.062.016.165.002.37-.01.556-.007.111-.015.215-.015.3l-.05.012c-.015-.029-.022-.038-.028-.046-.002-.003-.004-.005-.006-.009-.031.069-.054.084-.076.093h0c-.006.018-.006.101-.006.141l-.052.007c-.019-.068-.057-.108-.093-.146-.01-.01-.019-.02-.027-.03-.042.059-.108.101-.168.138-.058.036-.113.07-.116.105-.002.023.018.052.06.087l-.033.043ZM4.468,17.279l.015.018c.049.057.136.093.238.134.044.018.092.038.141.061-.003-.011-.004-.022-.003-.033.005-.062.068-.101.141-.147.065-.041.14-.087.17-.152l.021-.046.026.044c.011.018.027.035.046.055.017.018.037.039.055.064.003-.056.012-.069.038-.079.009-.004.03-.012.067-.114l.021-.059.028.056c.006.012.01.02.014.026.003-.066.008-.139.013-.214.016-.235.034-.502-.01-.671l.046-.024c.041.048.056.079.067.102.006.013.011.022.018.03,0-.044.003-.086.005-.127.011-.205.019-.367-.137-.525-.143-.152-.33-.109-.494-.071-.068.016-.133.031-.186.028-.029,0-.103-.023-.221-.057-.113-.033-.248-.072-.33-.086.03.079.021.106-.032.133l-.007.003c-.079.052-.122.028-.157-.004.002.012.002.025.003.041,0,.016,0,.033.003.054l.042.023-.09.03-.002-.018c-.072-.033-.151-.028-.237.015-.241.122-.454.498-.534.931.003-.004.005-.007.007-.01.012-.018.022-.03.079-.07l.051-.036-.009.061c-.015.102.002.164.027.258.013.049.029.108.044.185.025-.033.041-.05.054-.064.018-.02.029-.032.055-.076l.028-.047.02.051c.042.108.063.207.088.321.007.034.015.071.024.111.004-.014.006-.025.009-.035.009-.036.014-.058.042-.117l.015-.031.026.022c.094.079.132.118.154.142q.028.029.11.065c.029.013.069.031.123.055.046-.056.153-.128.245-.186l.03-.02Z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.69,11.475c-.198.383.346-.127,1.2.513.158.119.385.589.385.807-.182-.039-.503-.218-.503-.218,0,0,.422.244.422.68-.133-.083-.245-.116-.289-.218,0,.141.119.321.119.539-.081-.065-.213-.146-.304-.195.126.218-.319.192-.141.334-.311-.045-.494-.064-.62-.282-.067.045-.164.116-.166.191.01.008-.339-.134-.294-.275-.065.091-.208.141-.223.243-.177-.175-.25-.193-.31-.419-.079.102-.084.102-.163.205-.059-.359-.059-.346.059-.653-.084.055-.153.111-.237.179.078-.52.483-1.129,1.065-1.431h0Z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.65,13.748l-.108-.016c-.289-.042-.466-.067-.592-.269-.049.034-.128.093-.138.153l.006.005-.01.016c-.011.017-.025.011-.07-.01-.077-.036-.236-.121-.262-.221-.021.021-.046.039-.069.057-.054.042-.105.081-.113.134l-.006.04-.029-.029c-.039-.038-.072-.069-.102-.096-.098-.09-.156-.142-.202-.293-.024.031-.04.051-.057.07-.021.026-.042.051-.081.102l-.029.038-.01-.06c-.053-.322-.055-.343.038-.589-.059.042-.114.087-.18.141l-.042.034.008-.053c.086-.565.526-1.157,1.071-1.442l.016-.031.027.055-.012.006c-.03.059-.041.096-.033.11.011.018.071.016.141.015.209-.004.598-.012,1.089.357.165.124.393.602.393.824v.026l-.025-.005c-.092-.019-.216-.073-.319-.122.121.117.263.309.263.564v.037l-.032-.02c-.035-.022-.069-.04-.101-.058-.058-.032-.108-.059-.146-.096.009.038.023.079.038.124.033.098.07.209.07.334v.043l-.034-.027c-.064-.052-.165-.115-.251-.165.004.02.004.039-.001.056-.017.058-.077.089-.13.117-.033.017-.07.037-.072.053,0,.005.002.019.035.045l.061.046ZM12.964,13.405l.011.019c.113.196.269.224.548.264-.007-.012-.01-.024-.008-.036.004-.039.046-.061.094-.086.046-.024.098-.051.11-.092.007-.023.001-.049-.017-.081l-.037-.064.065.035c.077.042.188.109.272.17-.007-.101-.038-.194-.066-.277-.026-.078-.051-.152-.051-.218l.04-.008c.03.068.095.104.179.15.022.012.045.025.07.039-.023-.396-.407-.622-.411-.625l.02-.036s.292.162.472.21c-.017-.219-.227-.653-.376-.764-.479-.36-.859-.352-1.064-.348-.096.002-.153.003-.176-.034-.014-.022-.012-.052.007-.099-.494.279-.891.812-.991,1.331.068-.055.126-.1.195-.146l.054-.036-.032.082c-.103.266-.106.276-.057.574.022-.028.037-.047.053-.066.021-.025.042-.051.081-.102l.026-.033.011.041c.045.171.097.218.201.313.023.021.049.045.078.073.022-.051.071-.088.118-.125.036-.028.074-.057.098-.091l.037.018c-.006.019-.003.038.009.06.044.082.193.156.249.181.019-.069.096-.129.171-.18l.017-.013Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.263,11.723l.063.022-.41,1.521-.063-.022.41-1.521Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.927,13.287l-.095-.033.419-1.553.095.033-.419,1.553ZM11.872,13.233l.031.011.402-1.489-.031-.011-.402,1.489Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.717,11.853l.049-.045.825,1.45-.049.045-.825-1.45Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.538,13.329l-.842-1.48.074-.069.842,1.48-.074.069ZM12.738,11.856l.808,1.42.024-.022-.808-1.42-.024.022Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.539,11.694l.066-.012.195,1.775-.066.012-.195-1.775Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.719,13.488l-.199-1.808.099-.018.199,1.808-.099.018ZM12.557,11.708l.192,1.741.033-.006-.192-1.741-.033.006Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.966,11.926l.043-.051.963,1.315-.043.051-.963-1.315Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.928,13.268l-.983-1.343.065-.077.983,1.343-.065.077ZM12.987,11.927l.942,1.287.021-.025-.942-1.287-.021.025Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.643,11.765l.059-.031.526,1.662-.059.031-.526-1.662Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.159,13.451l-.536-1.694.089-.046.536,1.694-.089.046ZM12.663,11.773l.516,1.629.029-.015-.516-1.629-.029.015Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.37,11.677h.067v1.792h-.067v-1.792Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.453,13.485h-.1v-1.826h.1v1.826ZM12.387,13.452h.033v-1.759h-.033v1.759Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.947,11.799l.017-.064,1.026.556-.017.064-1.026-.556Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.983,12.38l-1.056-.573.026-.097,1.056.573-.026.097ZM12.966,11.79l.995.54.008-.031-.995-.54-.008.031Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.36,11.681l.066.009-.232,1.65-.066-.009.232-1.65Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.209,13.359l-.099-.014.237-1.683.099.014-.237,1.683ZM12.147,13.317l.033.005.227-1.617-.033-.005-.227,1.617Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934,11.932l.024-.062,1.095.761-.024.062-1.095-.761Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.037,12.719l-1.123-.78.036-.094,1.123.78-.036.094ZM12.954,11.926l1.067.741.012-.03-1.067-.741-.012.03Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.298,15.5l.043.044-.968,1.185-.043-.044.968-1.185Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.374,16.753l-.067-.068.989-1.21.067.068-.989,1.21ZM3.352,16.683l.02.02.947-1.159-.02-.02-.947,1.159Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.622,15.792l.059-.021.089,1.601-.059.021-.089-1.601Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.696,17.416l-.091-1.636.092-.033.091,1.636-.092.033ZM4.64,15.803l.087,1.567.027-.01-.087-1.567-.027.01Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54,15.582l.059.015-.569,1.644-.059-.015.569-1.644Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.041,17.261l-.092-.023.58-1.676.092.023-.58,1.676ZM3.993,17.214l.027.007.558-1.612-.027-.007-.558,1.612Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8,15.953l.057-.029.222,1.315-.057.029-.222-1.315Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.009,17.292l-.228-1.349.088-.044.228,1.349-.088.044ZM4.818,15.962l.216,1.28.026-.013-.216-1.28-.026.013Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.597,15.685l.062-.004-.247,1.672-.062.004.247-1.672Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.331,17.375l.252-1.706.096-.006-.252,1.706-.096.006ZM4.612,15.701l-.242,1.639.028-.002.242-1.639-.028.002Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.406,15.501l.056.026-.738,1.584-.056-.026.738-1.584Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.731,17.133l-.086-.04.753-1.614.086.04-.753,1.614ZM3.69,17.076l.025.012.724-1.553-.025-.012-.724,1.553Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.836,15.833l.041-.05.625.89-.041.05-.625-.89Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46,16.75l-.644-.918.063-.077.644.918-.063.077ZM4.857,15.833l.605.861.019-.023-.605-.861-.019.023Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.397,15.501l.051.034-.873,1.368-.051-.034.873-1.368Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58,16.926l-.079-.052.891-1.396.079.052-.891,1.396ZM3.546,16.864l.023.015.855-1.34-.023-.015-.855,1.34Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.771,15.946l.046-.046.598,1.097-.046.046-.598-1.097Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.365,17.071l-.615-1.128.07-.07.615,1.127-.07.071ZM4.791,15.949l.581,1.067.021-.021-.581-1.067-.021.021Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.112,15.673l.06.023-.389,1.635-.06-.023.389-1.635Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.794,17.354l-.091-.036.397-1.668.091.036-.397,1.668ZM24.742,17.297l.028.011.382-1.602-.028-.011-.382,1.602Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.543,15.813l.046-.049.783,1.559-.046.049-.783-1.559Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.321,17.4l-.799-1.59.071-.074.799,1.59-.071.074ZM25.563,15.816l.767,1.527.022-.023-.767-1.527-.022.023Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.374,15.641l.062-.013.185,1.908-.062.013-.185-1.908Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.544,17.569l-.189-1.941.095-.019.189,1.941-.095.019ZM25.392,15.655l.182,1.875.029-.006-.182-1.874-.029.005Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.78,15.891l.041-.055.814,1.26-.041.055-.814-1.26Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.593,17.18l-.834-1.29.062-.083.834,1.29-.062.083ZM25.8,15.892l.795,1.23.019-.026-.795-1.23-.019.026Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.473,15.718l.056-.033.499,1.786-.056.033-.499-1.786Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.961,17.529l-.508-1.82.086-.05.508,1.82-.086.05ZM25.492,15.726l.49,1.753.026-.016-.49-1.753-.026.016Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.213,15.623h.063v1.833h-.063v-1.833Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.293,17.473h-.097v-1.867h.097v1.867ZM25.23,17.44h.03v-1.8h-.03v1.8Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.761,15.754l.016-.069.973.598-.016.069-.973-.598Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.745,16.378l-1.003-.616.024-.103,1.003.616-.024.103ZM25.78,15.746l.943.579.008-.035-.943-.58-.008.036Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.204,15.627l.063.01-.22,1.774-.063-.01.22-1.774Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.061,17.43l-.096-.015.224-1.807.096.015-.224,1.807ZM25.002,17.387l.03.005.216-1.741-.03-.005-.216,1.741Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.749,15.898l.023-.067,1.039.818-.023.067-1.039-.818Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.796,16.743l-1.067-.84.034-.1,1.067.84-.034.1ZM25.769,15.892l1.011.796.011-.033-1.011-.796-.011.033Z",
    style: {
      fill: "#999"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/SZ.0f43e526ffe84bfde68f2aad8466fdeb.svg";
export { ForwardRef as ReactComponent };